import React, { useEffect,useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch  } from "react-redux";
import { yupResolver } from '@hookform/resolvers/yup';
import ClientValidationSchema from 'src/validation/ClientValidationSchema';
import { ValidationMessages } from 'src/components/common/ValidationMessage';
import { resetSingleClient, resetStateIdele,deleteClient } from 'src/store/client';

const ClientForm = (props) => {
  const {
    id = 0
  } = props;
  
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [validationMessages, setValidationMessages] = useState([]);
  const client            = useSelector((state) => state.client.singleData);
  const clientStatus      = useSelector((state) => state.client.status);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(ClientValidationSchema),
    mode: 'onSubmit',
    defaultValues: {
        id: id,    }
  });

  const onSubmit = (data) => {
    const updatedData = {
      ...data,
      memo: data.memo === "" ? null : data.memo,
    };
    navigate("/clientConfirm", { state: { formData: updatedData } });
  };
  

  const clickBackBtn = () => {
      navigate("/clientList");
  };


   const clickDeleteBtn = async () => {
      const deleteConfirmed = window.confirm("Are you sure you want to delete?");
      if (!deleteConfirmed) {
        return; // Exit if the user cancels the confirmation
      }
      const response = await dispatch(deleteClient(id));
      if (deleteClient.fulfilled.match(response)) {
        setValidationMessages(response.payload.message);
        navigate("/clientList"); 
      }
      else if (deleteClient.rejected.match(response)) {
        setValidationMessages(response.error.message);
      }
    };

  useEffect(() => {
    if (location.state?.formData) {
      reset(location.state.formData);

    }
    else if (client && Object.keys(client).length !== 0) {
      reset(client);
    }
  }, [location.state, reset, client]);

  useEffect(() => {
    if (location.state?.formData) {
      reset(location.state.formData);
    }
    
  }, [location.state, reset]);

    useEffect(() => {
        const messagesArray = Object.values(errors).map((error) => error.message);
        setValidationMessages(messagesArray);
    }, [errors]);

      useEffect(() => {
        if (clientStatus === 'succeeded') {
            dispatch(resetStateIdele());
        }
    }, [clientStatus]);

    useEffect(() => {
      return () => {
        dispatch(resetSingleClient());
      };
    }, []);

  return (
    <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
      <input type="hidden" {...register("id")} />
      {validationMessages && validationMessages.length > 0 && (
        <div style={{ background: "#ffe4e2" }}>
            <ValidationMessages
              messages={validationMessages}
              onClose={() => setValidationMessages([])}
            />
        </div>
      )}
      {/* Name Field */}
      <div className="form-group">
        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>
            Name  *
        </label>
        <div className="col-sm-9">
        <input
            type="text"
            className="form-control"
            maxLength={128}
            {...register("name")}
          />
        </div>
      </div>

      <div className="form-group">
        <label htmlFor="memo" className="col-sm-3 control-label">
            Remarks
        </label>
        <div className="col-sm-9" style={{ marginTop: '5px' }}>
            <textarea
            className="form-control"
            {...register("memo")}
            rows="5"
            >
            </textarea>
        </div>
      </div>

      {/* Buttons */}
      <div className="form-group text-center" style={{ marginTop: 60 }}>
        <button type="button" className="btn btn-default btn-lg" style={{ margin: "0 10px" }} onClick={clickBackBtn}>
          Back
        </button>
        <button type="submit" className="btn btn-success btn-lg jq-confirm_data" style={{ margin: "0 10px" }}>
          Confirm
        </button>
      </div>
      {id ? 
        <div className="form-group text-center">
          <button type="button" className="btn btn-default btn-lg" style={{ margin: "0 10px" }} onClick={clickDeleteBtn}>
            Delete
          </button>
        </div>
        : null
      }
    </form>
  );
};

export default ClientForm;
